import { type SupportedLocale } from '@zep-us/i18n';
import { useTranslation } from 'next-i18next';
import { useLocale } from '@/hooks';
import { MainAwards } from './MainAwards';
import { SouthEastAsiaAward } from './SouthEastAsiaAward';
import { SubAwards } from './SubAwards';
const SOUTH_EAST_ASIA_LOCALES: SupportedLocale[] = ['ms', 'id', 'th', 'fil', 'vi', 'km'];

// Award Section 보여지는 locale
const AWARD_SHOWN_LOCALES: SupportedLocale[] = [...SOUTH_EAST_ASIA_LOCALES, 'ko'];
export const AwardSection = ({
  locale
}: {
  locale: SupportedLocale;
}) => {
  const shouldShowAward = AWARD_SHOWN_LOCALES.includes(locale);
  if (!shouldShowAward) {
    return null;
  }
  return <section className="flex flex-col items-center justify-center gap-lg px-md pb-2xl pt-3xl mobile-lg:px-lg tablet-lg:px-2xl" data-sentry-component="AwardSection" data-sentry-source-file="Award.tsx">
      <Title data-sentry-element="Title" data-sentry-source-file="Award.tsx" />
      <Awards data-sentry-element="Awards" data-sentry-source-file="Award.tsx" />
    </section>;
};
const Title = () => {
  const {
    locale
  } = useLocale();
  const {
    t
  } = useTranslation(['landing']);
  return <div className="flex flex-col items-center gap-sm" data-sentry-component="Title" data-sentry-source-file="Award.tsx">
      <span className="text-center text-display-sm-extrabold">
        {t('landing.award.title')}
      </span>
      <span className="text-center text-body-lg-semibold text-neutral">
        {locale === 'ko' ? '수업의 변화를 이끌며, 다양한 공공·산업 기관에서 혁신성을 인정받았습니다' : t('landing.award.description')}
      </span>
    </div>;
};
const Awards = () => {
  const {
    locale
  } = useLocale();
  const isSouthEastAsia = SOUTH_EAST_ASIA_LOCALES.includes(locale);
  if (isSouthEastAsia) {
    return <SouthEastAsiaAward />;
  }
  return <div className="my-md flex w-full flex-col gap-xl pt-[30px] tablet-sm:max-w-[964px] tablet-sm:pt-[36px]" data-sentry-component="Awards" data-sentry-source-file="Award.tsx">
      <MainAwards data-sentry-element="MainAwards" data-sentry-source-file="Award.tsx" />
      <SubAwards data-sentry-element="SubAwards" data-sentry-source-file="Award.tsx" />
    </div>;
};